__turbopack_context__.v({
  "root": "Vf0rzq_root",
  "sticky": "Vf0rzq_sticky",
  "textContainer": "Vf0rzq_textContainer",
});
